/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

export const simpleHook = <
  Target extends Record<MethodName, (...args: any) => any>,
  MethodName extends keyof Target,
  Fn extends Target[MethodName],
>(
  target: Target,
  methodName: MethodName,
  hook: (response: ReturnType<Fn>, args: Parameters<Fn>) => unknown,
) => {
  target[methodName] = new Proxy(target[methodName], {
    apply(targetFn: Fn, ctx: Target, args: Parameters<Fn>) {
      const response = Reflect.apply(targetFn, ctx, args);
      return hook(response, args);
    },
  });
};
